export default __webpack_public_path__ + "imgs/diy.248c51205a09e739ca9975bf11621043.svg";